import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

export const enum EDITORMESSAGETYPE {
  View100,
  ViewFit,
  SelectObject,
  SelectPage,
}
export class EditorMessage {
  type: EDITORMESSAGETYPE;
  data: any;
}

export const enum EXAMMESSAGETYPE {
  RunAction,
}
export class ExamMessage {
  type: EXAMMESSAGETYPE;
  data: any;
}

export const enum PAGEPROPERTY {
  Background,
  Icon,
}
export class PagePropertyChange {
  type: PAGEPROPERTY;
  value: any;
}

@Injectable()
export class EventsHubService {
  private editorMessagesSubject: Subject<EditorMessage>;
  private examMessagesSubject: Subject<ExamMessage>;
  private pagePropertyChangeSubject: Subject<PagePropertyChange>;
  private changePageSubject: Subject<number>;

  constructor() {
    this.editorMessagesSubject = new Subject();
    this.examMessagesSubject = new Subject();
    this.pagePropertyChangeSubject = new Subject();
    this.changePageSubject = new Subject();
  }

  setEditorMessage(msg: EditorMessage): void {
    this.editorMessagesSubject.next(msg);
  }
  get onEditorMessage(): Observable<EditorMessage> {
    return this.editorMessagesSubject.asObservable();
  }

  setExamMessage(msg: ExamMessage): void {
    this.examMessagesSubject.next(msg);
  }
  get onExamMessage(): Observable<ExamMessage> {
    return this.examMessagesSubject.asObservable();
  }

  setPagePropertyChange(data: PagePropertyChange): void {
    this.pagePropertyChangeSubject.next(data);
  }
  get onPagePropertyChange(): Observable<PagePropertyChange> {
    return this.pagePropertyChangeSubject.asObservable();
  }

  changePage(pageIndex: number): void {
    this.changePageSubject.next(pageIndex);
  }
  get onChangePage(): Observable<number> {
    return this.changePageSubject.asObservable();
  }
}
